import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getInterventionsBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const interventionsItem = {
    label: t('interventions'),
    path: APP_URLS.dashboard.interventions.index.getPathWithQuery(),
  };

  return [
    {
      condition:
        APP_URLS.dashboard.interventions.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('interventions'),
        },
      ],
    },
    {
      condition:
        APP_URLS.dashboard.interventions.categories.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: t('categories'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.interventions.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: t('create-intervention'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.interventions.edit.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.interventions.view.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.interventions.viewActions.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: t('view-intervention'),
          path: APP_URLS.dashboard.interventions.view.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
            },
          }),
        },
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.interventions.actionAdd.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: t('view-intervention'),
          path: APP_URLS.dashboard.interventions.viewActions.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
            },
          }),
        },
        {
          label: t('create-an-action'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.interventions.actionEdit.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.interventionId}`,
            actionId: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: t('view-intervention'),
          path: APP_URLS.dashboard.interventions.viewActions.getDynamicPath({
            pathParts: {
              id: `${entity?.interventionId}`,
            },
          }),
        },
        {
          label: t('edit-an-action'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.interventions.actionView.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.interventionId}`,
            actionId: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        interventionsItem,
        {
          label: t('view-intervention'),
          path: APP_URLS.dashboard.interventions.viewActions.getDynamicPath({
            pathParts: {
              id: `${entity?.interventionId}`,
            },
          }),
        },
        {
          label: t('view-an-action'),
        },
      ],
    },
  ];
}
